import { themeAtom } from "../../shared/atoms";
import { NotificationM } from "../models/notifications.models";
import { openNotificationUrl } from "../services/notifications.service";
import { formatDistanceToNowStrict, format } from "date-fns";
import { useAtomValue } from "jotai";
import { useNavigate } from "react-router-dom";
import sanitizeHtml from "sanitize-html";
import { twMerge } from "tailwind-merge";

interface Props {
  notification: NotificationM;
}

export const Notification: React.FC<Props> = ({ notification }) => {
  const theme = useAtomValue(themeAtom);

  const bgColor = notification.IS_READ
    ? twMerge("border-transparent", theme.headerComponent.notifications.isReadBackground)
    : twMerge(theme.headerComponent.notifications.border, theme.headerComponent.notifications.itemBackground);
  const createdAt = getNotificationDate(new Date(notification.CREATED_AT));
  const navigate = useNavigate();

  const description = sanitizeHtml(notification.DESCRIPTION, {
    allowedTags: ["b"],
  });

  return (
    <div
      onClick={() => openNotificationUrl(notification, navigate)}
      className={twMerge(
        "relative mx-4 block rounded-lg border px-4 py-3 text-sm",
        bgColor,
        theme.headerComponent.notifications.notificationText,
      )}
      key={notification.ID}
    >
      <p dangerouslySetInnerHTML={{ __html: description }}></p>
      <p className={twMerge("font-bold", theme.myVesselsTable.tailwind.linkText)}>{notification?.CTA_TEXT}</p>
      <p className={twMerge("mt-2 text-xs", theme.uwhcAssistant.text)}>{createdAt}</p>
      {!notification.IS_READ && (
        <span
          className={twMerge(
            "absolute left-[-5px] top-[-5px] size-[10px] rounded-full border",
            theme.headerComponent.notifications.readDotBorder,
          )}
          style={{ backgroundColor: theme.headerComponent.inline.dotActive }}
        />
      )}
    </div>
  );
};

export const getNotificationDate = (date: Date): string => {
  const daysPassedSinceToday = formatDistanceToNowStrict(date, { unit: "day" });
  switch (daysPassedSinceToday) {
    case "0 days":
      return "Today";
    case "1 day":
      return "Yesterday";
    default:
      return format(date, "dd MMM yyyy");
  }
};
